
<template>
  <!-- ================= LOADING OVERLAY ================= -->
  <div v-if="loading" class="loading-overlay">
    <md-progress-spinner
        md-mode="indeterminate"
        :md-diameter="60"
        :md-stroke="6">
    </md-progress-spinner>

    <div class="loading-text">
      Loading List...
    </div>
  </div>

  <!-- ================= ACTUAL CONTENT ================= -->
  <div v-else>

    <!-- 🔽 EVERYTHING YOU ALREADY HAVE GOES HERE 🔽 -->
    <div class="md-layout">

      <div class="md-layout-item md-medium-size-20 md-xsmall-size-50 md-size-20"
           v-for="status in statuses"
           :key="status.key"
           @click="statuesFilter(status.key)">
        <md-card :class="{ 'active-status-card': filteredStatus === status.key }">
          <md-card-header :class="'md-card-header-icon md-card-header-' + status.color">
            <div class="card-icon">
              <md-icon>{{ status.icon }}</md-icon>
            </div>
            <h4 class="title">{{ status.title }}</h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout text-center text-primary">
              <h3>{{ status.count }}</h3>
            </div>
          </md-card-content>
        </md-card>
      </div>
        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Utilization Sheet Summary List</h4>
                </md-card-header>
                <md-card-content>

                    <md-table
                            :value="table"
                            :md-sort.sync="sortation.field"
                            :md-sort-order.sync="sortation.order"
                            :md-sort-fn="customSort"
                            class="paginated-table table-striped table-hover"
                    >
                        <md-table-toolbar>
                          <div class="filter-row">
                            <div class="filter-item">
                              <select-input
                                  v-model="filters.guidance_type"
                                  :options="guidanceTypes"
                                  name="name"
                                  track-by="id"
                                  :searchable="true"
                                  :allow-empty="true"
                                  placeholder="Guidance Type"
                                  @input="onGuidanceTypeChange"
                              />
                            </div>

                            <div class="filter-item">
                              <select-input
                                  v-model="filters.pay_code"
                                  :options="payCodes"
                                  name="name"
                                  track-by="id"
                                  :searchable="true"
                                  :allow-empty="true"
                                  placeholder="Pay Code"
                                  @input="applyFilters"
                              />
                            </div>


                            <div class="filter-item">
                              <select-input
                                  v-model="selectedStation"
                                  :options="stations"
                                  name="name"
                                  track-by="id"
                                  :searchable="true"
                                  :allow-empty="true"
                                  placeholder="Station"
                                  @input="onFilterStationChange"
                              />
                            </div>

                            <div class="filter-item">
                              <select-input
                                  v-model="selectedVendor"
                                  :options="vendors"
                                  name="name"
                                  track-by="id"
                                  :searchable="true"
                                  :allow-empty="true"
                                  placeholder="Vendor"
                                  :disabled="!filters.station_id"
                                  @input="onVendorFilterChange"
                              />
                            </div>

                          </div>
                            <md-field>
                                <label>Per page</label>
                                <md-select v-model="pagination.perPage" name="pages">
                                    <md-option
                                            v-for="item in pagination.perPageOptions"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                    >
                                        {{ item }}
                                    </md-option>
                                </md-select>
                            </md-field>

                            <md-field>
                                <md-input
                                        v-model="query"
                                        type="search"
                                        class="mb-3"
                                        clearable
                                        style="width: 200px"
                                        placeholder="Search ..."
                                >
                                </md-input>
                            </md-field>
                        </md-table-toolbar>

                      <md-table-row
                          slot="md-table-row"
                          slot-scope="{ item }"
                      >
<!--                        <template v-if="item.invoices && item.invoices.length > 0">-->
                            <md-table-cell md-label="Voucher Number" md-sort-by="voucher_number">{{
                                item.voucher_number || '---'
                                }}<br />
                              <badge :type="guidanceTypeBadge(item.guidance_type)">
                              {{
                                item.guidance_type || '--'
                              }}({{item.pay_code || '--'}})
                              </badge>
                            </md-table-cell>
                            <md-table-cell md-label="Sheet Date" md-sort-by="start_date">{{
                                item.start_date?new Date( item.start_date).toLocaleDateString():""
                                }} -
                                {{
                                item.end_date?new Date( item.end_date).toLocaleDateString():""
                                }}
                            </md-table-cell>
                            <md-table-cell md-label="Payment Date" md-sort-by="invoice_date">{{
                                item.payment_date? new Date(item.payment_date).toLocaleDateString():""
                                }}
                            </md-table-cell>
                            <md-table-cell md-label="Created At" md-sort-by="created_at">{{
                                new Date(item.created_at).toLocaleDateString()
                                }}
                            </md-table-cell>
                            <md-table-cell md-label="Sheet Count" md-sort-by="invoices">{{
                                item.invoices.length
                                }}
                            </md-table-cell>
                          <md-table-cell md-label="Vendor" md-sort-by="vendor">{{
                              item.vendor?item.vendor.name:''
                            }}
                          </md-table-cell>
                          <md-table-cell md-label="Amount" md-sort-by="invoices">{{
                              currencyFormat(item.total)
                            }}
                          </md-table-cell>
                            <md-table-cell md-label="Status" md-sort-by="status">
                              <badge :type="guidanceBadge(item.status)">{{
                                getStatus(item.status)
                                }}
                              </badge>
                            </md-table-cell>

                            <md-table-cell md-label="Actions">
                                <md-button
                                        class="md-icon-button md-raised md-round md-info"
                                        @click="goToView(item.id)"
                                        style="margin: 0.2rem"
                                >
                                  <badge :type="guidanceTypeBadge(item.guidance_type)">
                                    <md-icon>search</md-icon>
                                  </badge>
                                </md-button>
                            </md-table-cell>
<!--                        </template>-->
                        </md-table-row>
                    </md-table>
                    <div class="footer-table md-table">
                        <table>
                            <tfoot>
                            <tr>
                                <th
                                        v-for="item in footerTable"
                                        :key="item.invoice_number"
                                        class="md-table-head"
                                >
                                    <div class="md-table-head-container md-ripple md-disabled">
                                        <div class="md-table-head-label">
                                            {{ item }}
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </md-card-content>

                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                        </p>
                    </div>
                    <pagination
                            class="pagination-no-border pagination-success"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                    />
                </md-card-actions>
            </md-card>
        </div>
      </div>
    </div>
</template>

<script>
import _ from 'lodash';
import Pagination from '@/components/Pagination';
import Badge from "@/components/Badge.vue";
import formMixin from "@/mixins/form-mixin";
import badgeMixin from "@/mixins/badge-mixin";
import SelectInput from "@/components/Inputs/SelectInput.vue";
// import Swal from "sweetalert2";

export default {
    components: {
      SelectInput,
      Badge,
        pagination: Pagination,
    },
  mixins: [formMixin, badgeMixin],

    data: () => ({
      filters: {
        pay_code: null,
        guidance_type: null,
        vendor_id: null,
        station_id: null,
      },
      selectedStation: null,
      selectedVendor: null,
      payCodes: [],
      //   { id: 'MH', name: 'Man Hour(MH)' },
      //   { id: 'PT', name: 'Tonnage(PT)' },
      //   { id: 'PU', name: 'Quantity(PU)' },
      //   { id: 'TU', name: 'TEUs(TU)' },
      // ],

      guidanceTypes: [
        { id: 'Per Man Hour', name: 'Per Man Hour' },
        { id: 'Per Work Done', name: 'Per Work Done' },
      ],

      vendors: [],
      stations: [],
        statuses: [],
        vouchers: [],
        table: [],
        footerTable: [
            'Voucher Number',
            'Sheet Date',
            'Payment Date',
            'Created At',
            'Sheet Count',
            'Vendor',
            'Amount',
            'Status',
            'Actions'],

        query: null,
      loading: true,   // 👈 IMPORTANT
        sortation: {
            field: 'created_at',
            order: 'asc',
        },
      filteredStatus: 'Active',

        pagination: {
            perPage: 10,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
        },

        total: 0,
    }),
    async mounted () {
        // load statuses once when component mounts
        // let paramsStatus = { filter: { model: 'Voucher' } };
        // await this.$store.dispatch('statusOptions/list', paramsStatus);
        // this.statuses = this.$store.getters['statusOptions/list'];
      await this.getStatusCounts();
      await this.$store.dispatch('stations/list');
      this.stations = this.$store.getters['stations/list'] || [];
        // then load first page of invoices
      await  this.getList();

    },


    computed: {
        sort () {
            if (this.sortation.order === 'desc') {
                return `-${this.sortation.field}`;
            }
            return this.sortation.field;
        },

        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },

        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
    },

    watch: {
      // Watch for pagination currentPage changes
      'pagination.currentPage': {
        handler: function(newVal, oldVal) {
          if (newVal !== oldVal) {
            console.log('Page changed from', oldVal, 'to', newVal);
            this.getList();
          }
        }
      },

      // Watch for perPage changes
      'pagination.perPage': {
        handler: function(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.pagination.currentPage = 1;
            this.getList();
          }
        }
      },
        // query: {
        //     handler: 'getListDebounced',
        //     immediate: true,
        // },
        // sortation: {
        //     handler: 'getList',
        //     immediate: false,
        //     deep: true,
        // },
        // pagination: {
        //     handler: 'getList',
        //     immediate: false,
        //     deep: true,
        // },
    },

    methods: {
      async onGuidanceTypeChange(guidanceType) {
        this.filters.guidance_type = guidanceType
            ? guidanceType
            : null;

        // Clear existing pay code
        this.selectedPayCode = null;
        this.filters.pay_code = null;

        // Set pay codes according to guidance type
        if (guidanceType) {
          if (guidanceType === 'Per Man Hour') {
            this.payCodes = [
              {
                id: 'MH',
                name: 'MH'
              }
            ];
          }

          if (guidanceType === 'Per Work Done') {
            this.payCodes = [
              {
                id: 'PT',
                name: 'Tonnage(PT)'
              },
              {
                id: 'PU',
                name: 'Quantity(PU)'
              },
              {
                id: 'TU',
                name: 'TEUs(TU)'
              }
            ];
          }
        } else {
          this.payCodes = [];
        }

        this.pagination.currentPage = 1;

        await this.getList();
      },
      async onFilterStationChange(stationId) {
        console.log('STATION ID:', stationId);

        this.filters.station_id = stationId;
        this.filters.vendor_id = null;
        this.selectedVendor = null;
        this.vendors = [];

        if (!stationId) {
          await this.getVendors();
          this.pagination.currentPage = 1;
          await this.getList();
          return;
        }

        try {
          await this.$store.dispatch(
              'stations/get',
              stationId
          );

          const station =
              this.$store.getters['stations/station'];

          console.log('STATION:', station);

          this.vendors = (station.activeTariffs || [])
              .map(tariff => tariff.vendor)
              .filter(vendor => vendor);

          this.pagination.currentPage = 1;

          await this.getList();

        } catch (error) {
          console.error('Failed to load station:', error);
        }
      },
      async onVendorFilterChange(vendorId) {
        this.filters.vendor_id = vendorId ? vendorId : null;

        this.pagination.currentPage = 1;

        await this.getList();
      },

      async clearFilters() {
        this.filters = {
          pay_code: null,
          guidance_type: null,
          vendor_id: null,
          station_id: null,
        };

        this.selectedStation = null;
        this.selectedVendor = null;

        await this.getVendors();

        this.pagination.currentPage = 1;

        await this.getList();
      },
      async getVendors() {
        await this.$store.dispatch('vendors/list')
        this.vendors = this.$store.getters['vendors/list'];
      },
      async applyFilters() {
        this.pagination.currentPage = 1;
        await this.getList();
      },
      // ============ FILTER HANDLERS ============
      statuesFilter(status) {
        this.filteredStatus = this.filteredStatus === status ? null : status;
        this.pagination.currentPage = 1;
        if(status==='Total'){
          this.clearFilters();
        }
        this.getList();
      },
      // ============ DATA FETCHING ============
      async getStatusCounts() {
        try {
          await this.$store.dispatch('vouchers/statusStatistics');
          this.statuses = this.$store.getters['vouchers/statistics'] || [];
        } catch (e) {
          console.error('Failed to fetch status counts', e);
          this.statuses = [];
        }
      },


        getListDebounced: _.debounce(function () {
            this.getList();
        }, 300),

        async getList () {
          this.loading = true
            let params = {
                ...(this.sort ? { sort: this.sort } : {}),
              filter: {
                ...(this.query ? { name: this.query } : {}),
                ...(this.filters.pay_code
                    ? { pay_code: this.filters.pay_code }
                    : {}),
                ...(this.filters.guidance_type
                    ? { guidance_type: this.filters.guidance_type }
                    : {}),
                ...(this.filters.vendor_id
                    ? { vendor: this.filters.vendor_id }
                    : {}),
                ...(this.filters.station_id
                    ? { station: this.filters.station_id }
                    : {})
              },
              // include:'invoices,invoices.invoiceItems,invoices.distributions,statuses,statuses.creator',
               include:'vendor,invoices',
                page: {
                    number: this.pagination.currentPage,
                    size: this.pagination.perPage,
                },
            };
          if (this.filteredStatus) {
            params.filter.status = this.filteredStatus;
          }

            try {
                await this.$store.dispatch('vouchers/list', params);
                this.table = this.$store.getters['vouchers/list'];
                this.total = this.$store.getters['vouchers/listTotal'];
              this.vouchers = this.$store.getters['vouchers/list'];

            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }finally {
              setTimeout(() => {
                this.loading = false
              }, 300)
            }
        },
        goToView (id) {
            this.$router.push({ name: 'View Utilization Sheet Summary', params: { id } });
        },


        async goToPreview (id) {
            try {
                await this.$store.dispatch('vouchers/execute', id);

                //  this.table = this.$store.getters["invoices/list"];
                await this.$store.dispatch('vouchers/get', id);
                const total_items = this.$store.getters['vouchers/voucher'].invoices.length;
                console.log(total_items);
                // this.total = this.$store.getters["invoices/listTotal"];
                if (total_items) {
                    await this.$store.dispatch(
                        'alerts/success',
                        'Good, ' + total_items + ' Items Generated successfully!'
                    );
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'NIL, No invoice item found!'
                    );
                }
                this.getList();
            } catch (e) {
                console.log(e);
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        customSort () {
            return false;
        },
        goBack () {
            this.$router.push({ name: 'List Payment Summary' });
        },
        currencyFormat (amount) {
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'TZS',
                maximumFractionDigits: 0,

                // These options are needed to round to whole numbers if that's what you want.
                // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                // maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
            });

            return  formatter.format(amount); /* $2,500.00 */
        },
      getStatus(status){
          return status?status:'New';
      }
    },
};

</script>
<style>
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.loading-text {
  margin-top: 12px;
  font-size: 14px;
  color: #555;
}
.filter-row {
  display: flex;
  align-items: flex-end;
  gap: 15px;
  width: 100%;
}

.filter-item {
  flex: 1;
  min-width: 180px;
  max-width: 250px;
}

</style>
